import React from "react";
import {Routes, Route} from "react-router-dom";
import Exchange from "../layout/exchange/Exchange";
import AddExchangePage from "../layout/exchange/AddExchange";


const ExchangePages = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Exchange/>}/>
                <Route path="/add" element={<AddExchangePage/>}/>
                <Route path="/update/:id" element={<AddExchangePage/>}/>
            </Routes>
        </>
    );
};

export default ExchangePages;
